// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__15xhC","question":"Question_question__3gHtb","description":"Question_description__3U4uH"};